<template>
  <v-container style="max-width:100vw;" v-if="currentUser">
    <!-- Drawer de filtros -->
    <v-navigation-drawer
      right
      app
      v-model="filtersOpen"
      style="top:0px; max-height:100vh!important;"
      :clipped="$vuetify.breakpoint.lgAndUp"
    >
      <filter-brands @filtersBrands="onFiltersChanged" />
    </v-navigation-drawer>

    <!-- Tabla -->
    <v-data-table
      class="elevation-0 px-6 py-4"
      :headers="headers"
      :items="brands"
      :options.sync="options"
      :server-items-length="total"
      :loading="loading"
      height="600"
      fixed-header
      :multi-sort="true"
      :footer-props="{
        'items-per-page-options': [15, 30, 50, 100, total>999?999:total]
      }"
    >
      <!-- Top toolbar -->
      <template v-slot:top>
        <v-toolbar flat class="mb-2">
          <v-toolbar-title>Marcas</v-toolbar-title>

          <v-btn icon @click="toggleFilters">
            <template v-if="activeFiltersCount>0">
              <v-badge overlap color="primary">
                <template v-slot:badge>{{ activeFiltersCount }}</template>
                <v-icon>mdi-filter</v-icon>
              </v-badge>
            </template>
            <template v-else>
              <v-icon>mdi-filter</v-icon>
            </template>
          </v-btn>

          <v-spacer></v-spacer>
        </v-toolbar>
      </template>

      <!-- Cols formateadas -->
      <template v-slot:[`item.created_at`]="{ item }">
        {{ formatDate(item.created_at) }}
      </template>

      <template v-slot:[`item.agent_name`]="{ item }">
        {{ item.agent_name }}
      </template>

      <template v-slot:[`item.agency_name`]="{ item }">
        {{ item.agency_name }}
      </template>

      <template v-slot:no-data>
        No existen marcas para los criterios seleccionados.
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import axios from 'axios'
import FilterBrands from './filter.vue'

export default {
  name: 'BrandsContainer',
  components: {
    'filter-brands': FilterBrands,
  },
  data: () => ({
    filtersOpen: false,
    loading: false,
    brands: [],
    total: 0,
    options: {
      page: 1,
      itemsPerPage: 15,
      sortBy: ['name'],        // sorts permitidos: name, phone, email, city, razon_social
      sortDesc: [false],
    },
    headers: [
      { text: 'Nombre', value: 'name' },
      { text: 'Email', value: 'email' },
      { text: 'Teléfono', value: 'phone' },
      { text: 'Ciudad', value: 'city' },
      { text: 'Razón Social', value: 'razon_social' }
    ],
  }),
  computed: {
    currentUser () {
      return this.$store.state.currentUser?.user || null
    },
    activeFiltersCount () {
      const raw = localStorage.getItem('filtersBrandsLength')
      const n = raw ? parseInt(raw, 10) : 0
      return Number.isNaN(n) ? 0 : n
    },
  },
  watch: {
    options: {
      deep: true,
      handler () {
        this.fetchBrands()
      }
    },
    currentUser () {
      this.fetchBrands()
    }
  },
  mounted () {
    this.fetchBrands()
  },
  methods: {
    toggleFilters () {
      this.filtersOpen = !this.filtersOpen
    },
    onFiltersChanged () {
      // cuando el drawer emite, recargamos
      this.fetchBrands()
    },
    buildSortParam (sortBy = [], sortDesc = []) {
      if (!Array.isArray(sortBy) || sortBy.length === 0) return ''
      const allowed = new Set(['name', 'phone', 'email', 'city', 'razon_social'])
      const parts = []
      sortBy.forEach((key, idx) => {
        if (!allowed.has(key)) return
        const desc = sortDesc?.[idx] === true
        parts.push((desc ? '-' : '') + key)
      })
      return parts.length ? `sort=${parts.join(',')}&` : ''
    },
    async fetchBrands () {
      this.loading = true
      try {
        const { page, itemsPerPage, sortBy, sortDesc } = this.options
        const base = process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/brands?'
        const savedFilter = localStorage.getItem('filtersBrands')
        const filterQS = savedFilter ? JSON.parse(savedFilter) : ''
        const sortQS = this.buildSortParam(sortBy, sortDesc)

        // Nota: reusé el mismo esquema que usas en otros módulos (page + itemsPerPage)
        const url = `${base}${sortQS || ''}${filterQS || ''}${filterQS || sortQS ? '&' : ''}page=${page}&itemsPerPage=${itemsPerPage}`
        const { data } = await axios.get(url)

        const items = Array.isArray(data?.data) ? data.data : []
        const metaTotal = data?.meta?.total ?? items.length

        this.brands = this.mapBrands(items)
        this.total = metaTotal
      } catch (e) {
        this.brands = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    mapBrands (rows) {
      return rows.map(r => ({
        id: r.id,
        name: r.name || '',
        phone: r.phone || '',
        email: r.email || '',
        city: r.city || '',
        razon_social: r.razon_social || '',
        created_at: r.created_at || '',
        origin_name: r.origin?.name || '',
        agency_name: r.agency?.name || '',
        agent_name: [r.agent?.name, r.agent?.last].filter(Boolean).join(' '),
      }))
    },
    formatDate (iso) {
      if (!iso) return ''
      // seguro contra "Invalid time value"
      const d = new Date(iso)
      return Number.isNaN(d.getTime()) ? '' : iso.slice(0,10)
    },
  }
}
</script>
